/**
 * Strips whatever a person actually pasted down to a bare hostname.
 *
 * The three things anyone types when asked for a domain are `cnx.com`, `@cnx.com` and
 * `https://cnx.com/careers` — and the backend accepts only the first. Normalizing here means
 * the other two work rather than coming back as a validation error the typist has to decode.
 *
 * This is the COURTESY copy, not the rule. The server lower-cases, de-duplicates, enforces the
 * shape and owns the "already claimed by another client" check; nothing here is relied on for
 * correctness, and a value this misses simply comes back as the backend's own message.
 */
export function normalizeDomain(raw: string): string {
  let value = raw.trim().toLowerCase()
  if (!value) return ''
  value = value.replace(/^[a-z]+:\/\//, '')
  // An email or an "@domain" shorthand: keep what follows the last @.
  const at = value.lastIndexOf('@')
  if (at !== -1) value = value.slice(at + 1)
  // Path, query and port are all noise on a hostname.
  value = value.split('/')[0] ?? ''
  value = value.split('?')[0] ?? ''
  value = value.split(':')[0] ?? ''
  return value.replace(/\.+$/, '')
}
